import * as Yup from 'yup';
import { passwordRegex } from 'src/config/regex';

export const enterEmailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email must be a valid email')
    .required('Email is required'),
});

export const enterWorkSpaceValidationSchema = Yup.object().shape({
  workspace: Yup.string()
    .url('Workspace must be a valid workspace')
    .required('Workspace is required'),
});

export const signinValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email must be a valid email')
    .required('Email is required'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required')
    .matches(passwordRegex, {
      message:
        'Weak password. Your password must contain at least one lowercase letter, one uppercase letter, one numeric digit, one special character, and be at least 8 characters long.',
    }),
});
